<template>
  <v-card class="ma-2">
    <!-- Toobar -->
    <v-toolbar dense>
      <v-toolbar-title>Equivalência de Planos - Detalhar</v-toolbar-title>
      <v-spacer/>
      <v-btn
        small
        @click="
          $router.push({
            name: 'prov_equiv_conf',
            params: {keyId: $route.params.keyId},
          })
        "
      >
        <v-icon small title="Editar">fas fa-edit</v-icon>
      </v-btn>

      <v-btn small @click="$router.push(`/equivalence_configuration?recordId=${equivConf.referencePlan.id}`)">
        <v-icon small title="Voltar">fas fa-arrow-circle-left</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- Dados Principais -->
    <v-card tile class="pa-4">
      <v-card-title>Dados Principais</v-card-title>
      <v-card-text v-if="equivConf.id" class="d-flex justify-space-between">
        <v-sheet d-flex flex-column>
          <div class="text-subtitle-1">Plano Atual</div>
          <div v-if="equivConf.currentPlan">
            {{ equivConf.currentPlan.productCode }}.{{
              equivConf.currentPlan.description
            }}
          </div>
          <div v-if="!equivConf.currentPlan">-</div>
          <div class="text-subtitle-1">Início de Vigência</div>
          <div>{{ $util.formatDateToBR(equivConf.startAt, true) }}</div>
        </v-sheet>
        <v-sheet d-flex flex-column>
          <div class="text-subtitle-1">Plano Refêrencia</div>
          <div>
            {{ equivConf.referencePlan.productCode }}.{{
              equivConf.referencePlan.description
            }}
          </div>
          <div class="text-subtitle-1">Início de Vigência</div>
          <div>{{ $util.formatDateToBR(equivConf.endAt, true) }}</div>
        </v-sheet>
        <v-sheet d-flex flex-column>
          <div class="text-subtitle-1">1° Proposto</div>
          <div>
            {{
              equivConf.proposalPlanOne
                ? equivConf.proposalPlanOne.plan.productCode
                : ''
            }}.{{
              equivConf.proposalPlanOne
                ? equivConf.proposalPlanOne.plan.description
                : ''
            }}
          </div>
          <div class="text-subtitle-1">Ativo</div>
          <div>{{ equivConf.active ? 'Sim' : 'Não' }}</div>
        </v-sheet>
        <v-sheet d-flex flex-column>
          <div class="text-subtitle-1">2° Proposto</div>
          <div>
            {{
              equivConf.proposalPlanTwo
                ? equivConf.proposalPlanTwo.plan.productCode
                : ''
            }}.{{
              equivConf.proposalPlanTwo
                ? equivConf.proposalPlanTwo.plan.description
                : ''
            }}
          </div>
        </v-sheet>
        <v-sheet d-flex flex-column>
          <div class="text-subtitle-1">3° Proposto</div>
          <div>
            {{
              equivConf.proposalPlanThree
                ? equivConf.proposalPlanThree.plan.productCode
                : ''
            }}.{{
              equivConf.proposalPlanThree
                ? equivConf.proposalPlanThree.plan.description
                : ''
            }}
          </div>
        </v-sheet>
        <v-sheet d-flex flex-column>
          <div class="text-subtitle-1">4° Proposto</div>
          <div>
            {{
              equivConf.proposalPlanFour
                ? equivConf.proposalPlanFour.plan.productCode
                : ''
            }}.{{
              equivConf.proposalPlanFour
                ? equivConf.proposalPlanFour.plan.description
                : ''
            }}
          </div>
        </v-sheet>
        <v-sheet d-flex flex-column>
          <div class="text-subtitle-1">5° Proposto</div>
          <div>
            {{
              equivConf.proposalPlanFive
                ? equivConf.proposalPlanFive.plan.productCode
                : ''
            }}.{{
              equivConf.proposalPlanFive
                ? equivConf.proposalPlanFive.plan.description
                : ''
            }}
          </div>
        </v-sheet>
      </v-card-text>
      <v-progress-linear v-if="!equivConf.id" indeterminate/>
    </v-card>

    <v-expansion-panels accordion multiple tile>
      <v-expansion-panel>
        <v-expansion-panel-header
        ><span class="text-subtitle-1"
        >Equivalência(s)</span
        ></v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <div class="d-flex justify-end">
            <v-spacer/>
            <v-row dense justify="end">
              <v-col cols="3">
                <v-select
                  label="Região"
                  :items="regionList"
                  :loading="loadingRegionList"
                  :disabled="loadingRegionList"
                  item-value="id"
                  return-object
                  item-text="name"
                  v-model="selectedRegion"
                  clearable
                  class="pl-6"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="3">
                <v-select
                  label="Operadora Equivalente"
                  :items="carrierList"
                  :loading="loadingCarrierList"
                  :disabled="loadingCarrierList"
                  itemValue="id"
                  return-object
                  item-text="name"
                  v-model="selectedCarrier"
                  clearable
                  @change="onSelectedCarrier"
                  class="pl-6"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="3">
                <v-select
                  label="Plano Equivalente"
                  :items="planList"
                  :loading="loadingPlanList"
                  :disabled="loadingPlanList"
                  itemValue="id"
                  return-object
                  :item-text="
                    (i) => (i ? `${i.productCode} - ${i.description}` : '*')
                  "
                  v-model="selectedPlan"
                  clearable
                  class="pl-6"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
          </div>
          <div class="d-flex justify-center">
            <v-progress-linear v-if="loadingPlanEquivConf" indeterminate/>
            <table
              v-if="planEquivConf && !loadingPlanEquivConf"
              class="info-table"
            >
              <thead>
              <tr>
                <th>Refêrencia</th>
                <th>Equivalente(s)</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <th>Operadora / Plano / Região</th>
                <th>Operadora / Plano / Região</th>
              </tr>
              <tr>
                <td>{{ this.equivConf.referencePlan.carrierName }}</td>
                <td>{{ this.planEquivConf.equivalentPlan.carrierName }}</td>
              </tr>
              <tr>
                <td>
                  {{ this.equivConf.referencePlan.productCode }}-{{
                    this.equivConf.referencePlan.description
                  }}
                </td>
                <td>
                  {{ this.planEquivConf.equivalentPlan.productCode }}-{{
                    this.planEquivConf.equivalentPlan.description
                  }}
                </td>
              </tr>
              <tr>
                <td>{{ this.selectedRegion.name }}</td>
                <td>{{ this.selectedRegion.name }}</td>
              </tr>
              <tr>
                <th>Prestadores / Hospitais</th>
                <th>Prestadores / Hospitais</th>
              </tr>
              <tr v-for="poc in providersList" :key="poc.id">
                <td>{{ poc.ref.hide ? '-*-' : poc.ref.providerName }}</td>
                <td>{{ poc.equiv.hide ? '-*-' : poc.equiv.providerName }}</td>
              </tr>
              <tr>
                <th>Prestadores / Laboratórios</th>
                <th>Prestadores / Laboratórios</th>
              </tr>
              <tr v-for="poc in laboratoriesList" :key="poc.id">
                <td>{{ poc.ref.hide ? '-*-' : poc.ref.providerName }}</td>
                <td>{{ poc.equiv.hide ? '-*-' : poc.equiv.providerName }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Informações do Registro
        </v-expansion-panel-header>
        <v-expansion-panel-content></v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import EquivalenceConfigurationService from '@/services/insurancepricing/EquivalenceConfigurationService';
import ProductNetworkService from '@/services/odoo/ProductNetworkService';
import PlanEquivalenceConfigurationService from '@/services/insurancepricing/PlanEquivalenceConfigurationService';

export default {
  components: {},
  data() {
    return {
      equivConf: {},

      regionList: [],
      loadingRegionList: false,
      selectedRegion: null,

      carrierList: [],
      loadingCarrierList: false,
      selectedCarrier: null,

      planList: [],
      loadingPlanList: false,
      selectedPlan: null,

      planEquivConf: null,
      loadingPlanEquivConf: false,
      error: null,

      providersList: [],
      laboratoriesList: [],
      allProvidersList: [],
    };
  },
  methods: {
    async onSelectedCarrier(value) {
      if (!value) {
        this.planList = [];
        this.selectedPlan = null;
        return;
      }
      this.loadingPlanList = true;
      try {
        const response = await this.equivConfService.findPlansByCarrier(
          this.equivConf.id,
          value.id,
          this.selectedRegion.id
        );
        this.planList = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingPlanList = false;
      }
    },

    async loadInfoTable() {
      if (this.selectedRegion && this.selectedCarrier && this.selectedPlan) {
        this.loadingPlanEquivConf = true;

        const pecService = new PlanEquivalenceConfigurationService();
        Promise.all([
          pecService.findByEquivalenceConfigurationAndPlan({
            equivalentPlanId: this.selectedPlan.id,
            equivalenceConfigurationId: this.equivConf.id,
          }),
          this.equivConfService.findOrderConfigurationByParams(
            this.equivConf.id,
            {
              regionId: this.selectedRegion.id,
            },
          ),
        ])
          .then((responses) => {
            this.providersList = [];
            this.laboratoriesList = [];
            this.planEquivConf = responses[0].data;
            responses[1].data.forEach((el) => el.items.sort((a, b) => a.order - b.order));
            responses[1].data.forEach((el) => {

              if (el.recordType == 'hospital') {

                el.items.forEach((poc) => {
                  this.providersList.push({
                    id: poc.provOrdConfId,
                    ref: {providerName: poc.providerName, hide: poc.hide},
                    equiv: {
                      providerName: poc.providerName,
                      hide: poc.planEquivs[this.selectedPlan.id]
                        ? poc.planEquivs[this.selectedPlan.id]
                          .hideEquivalentProvider
                        : true,
                    },
                  });
                });
              }

              if (el.recordType == 'laboratory') {
                el.items.forEach((poc) => {
                  this.laboratoriesList.push({
                    id: poc.provOrdConfId,
                    ref: {providerName: poc.providerName, hide: poc.hide},
                    equiv: {
                      providerName: poc.providerName,
                      hide: poc.planEquivs[this.selectedPlan.id]
                        ? poc.planEquivs[this.selectedPlan.id]
                          .hideEquivalentProvider
                        : true,
                    },
                  });
                });
              }

            });
          })
          .catch((error) => console.log(error))
          .finally(() => (this.loadingPlanEquivConf = false));
      } else {
        this.providersList = [];
        this.laboratoriesList = [];
        this.planEquivConf = null;
      }
    }, 
  },

  watch: {
    selectedRegion(a, b) {
      this.loadInfoTable();
    }
    ,
    selectedCarrier(a, b) {
      this.loadInfoTable();
    }
    ,
    selectedPlan(a, b) {
      this.loadInfoTable();
    }
    ,
  }
  ,

  async created() {
    const equivConfId = this.$route.params.keyId;
    this.equivConfService = new EquivalenceConfigurationService();
    const response = await this.equivConfService.get(equivConfId);
    this.equivConf = response.data;
    try {
      this.loadingCarrierList = true;
      this.loadingRegionList = true;
      Promise.all([
        new ProductNetworkService().getRegionsByPlan(
          this.equivConf.referencePlan.id,
        ),
        this.equivConfService.findCarriers(equivConfId),
      ])
        .then((responses) => {
          this.regionList = responses[0].data;
          this.carrierList = responses[1].data;
        })
        .finally(() => {
          this.loadingCarrierList = false;
          this.loadingRegionList = false;
        });
    } catch (error) {
      this.error = error;
    }
  }
  ,
}
;
</script>

<style scoped>
.info-table {
  width: 75%;
  border: 1px solid var(--v-border-base);
  border-spacing: 0;
}

.info-table thead {
  background-color: var(--v-border-base);
}

.info-table td {
  text-align: center;
}

.info-table tbody th {
  background-color: var(--v-muted-base);
}

.info-table tr:nth-child(even) {
  background-color: var(--v-muted-base);
}
</style>
